import React from "react";
import { Link } from "gatsby";

export const Header = () => {
  return (
    <div className="border-b border-gray-200 py-4 -mx-4 px-4 sm:mx-0 sm:px-0">
      <div className="mx-6 sm:mx-10 flex items-center justify-between py-2">
        {/* <!-- Left Partition --> */}
        <Link to="/" className="text-lg mr-6 md:text-2xl font-bold">
          Canopus
        </Link>
        {/* <!-- Right Partition --> */}
        <div className="flex items-center justify-center gap-x-4 sm:gap-x-8">
          <Link
            to="/"
            className="text-gray-400 hover:text-gray-500 transition-colors uppercase font-bold text-sm"
          >
            docs
          </Link>
          <a
            href="https://github.com/canopusgraphql/canopus"
            className="text-gray-400 hover:text-gray-500 transition-colors uppercase font-bold text-sm"
          >
            source
          </a>
        </div>
      </div>
    </div>
  );
};
